import './share-dialog.scss'
import { useMemo, useCallback } from 'react'
import CommonModal from '@/components/CommonModal/CommonModal'
import { useStore } from '@/store'
import { useLocal } from '@/i18n/LocalContext'
import { toast } from '@/utils'

export default function ShareDialog() {
  const { $t } = useLocal()
  const { state, dispatch } = useStore()
  const shareDialogOpen = state.shareDialogModalOpen
  const playerId = state.login.userInfo.playerId
  const price = state.marketData.price
  const text = useMemo(
    () =>
      $t(
        '%{uid}#我的集市今日圣诞树收购价为%{num}圣诞币，前往圣诞庆典活动搜索我的集市进行出售吧！！！'
      )
        .replace('%{uid}', playerId || '-')
        .replace('%{num}', price.toString()),
    [playerId, price]
  )

  const onClose = useCallback(() => {
    dispatch({ type: 'setState', data: { shareDialogModalOpen: false } })
  }, [])

  const handleCopy = useCallback(() => {
    const hints = $t('复制成功')

    const doFallbackCopy = (value: string) => {
      try {
        const textarea = document.createElement('textarea')
        textarea.value = value
        textarea.setAttribute('readonly', 'readonly')
        textarea.style.position = 'fixed'
        textarea.style.left = '-9999px'
        document.body.appendChild(textarea)
        textarea.select()
        const ok = document.execCommand('copy')
        document.body.removeChild(textarea)
        return ok
      } catch {
        return false
      }
    }

    const tryClipboard = async () => {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        try {
          await navigator.clipboard.writeText(text)
          toast(hints, true)
          return
          // eslint-disable-next-line no-empty
        } catch {}
      }
      const ok = doFallbackCopy(text)
      if (ok) {
        toast(hints, true)
      }
    }

    tryClipboard()
  }, [text])

  return (
    <CommonModal
      open={shareDialogOpen}
      onClose={onClose}
      title={$t('分享集市')}
      type="share-dialog"
    >
      {[
        <div key="1" className="share-dialog">
          <p>{text}</p>
        </div>,
        <a key="2" className="share-dialog-btn btn2" onClick={handleCopy}>
          {$t('复制')}
        </a>,
      ]}
    </CommonModal>
  )
}
